import Select from "../../inputs/SelectBase";
import DeleteButton from "../../buttons/DeleteButton";
import { buscarCampo } from "../../../functions/dataFunctions";
//import { getStock } from "../../../services/cols/stock.service";
import { realtime } from "../../../services/store";
import { useEffect, useState } from "react";

// uso para carga de articulos para reparaciones & movimiento de stock

const FormComplete = ({
  grupos,
  formData,
  setFormData,
  handleChange,
  cargarOpciones,
}) => {
  // "coleccion" recibe por ej: stock & "campo" recibe por ej: "nombre" → para poder buscar nombre de articulos

  const [localStock, setLocalStock] = useState([]);

  useEffect(() => {
    const cargarStock = async () => {
      //const listado = await getStock();
      const listado = realtime.stock;
      setLocalStock(listado);
    };

    cargarStock();
  }, []);

  if (!grupos.length) return null;

  const onDelete = (grupoKey, index, campo) => {
    setFormData((prev) => ({
      ...prev,
      [grupoKey]: prev[grupoKey].filter((_, i) => i !== index),
    }));
  };

  return (
    <>
      {grupos.map((grupo) => {
        const campoRepuesto = grupo.items.find((i) => i.key === "repuesto");
        const campoCantidad = grupo.items.find((i) => i.key === "cantidad");

        return (
          <div key={grupo.key} className="form-box">
            <div className="form-info">
              <div className="form-info-2">
                <strong>{campoRepuesto.label}</strong>

                <Select
                  className="form-input"
                  options={cargarOpciones(campoRepuesto.optionsList)}
                  value={
                    cargarOpciones(campoRepuesto.optionsList).find(
                      (opt) => opt.value === formData[campoRepuesto.key],
                    ) || null
                  }
                  onChange={(opt) =>
                    handleChange(campoRepuesto.key, opt?.value || "")
                  }
                  placeholder="Seleccionar repuesto..."
                  noOptionsMessage={() => "Sin opciones"}
                />
              </div>

              <div className="form-row">
                <div>
                  <strong>{campoCantidad.label}</strong>

                  <input
                    className="form-input"
                    type="number"
                    value={formData[campoCantidad.key] ?? ""}
                    onChange={(e) =>
                      handleChange(campoCantidad.key, e.target.value)
                    }
                  />
                </div>
                {}
                <button
                  type="button"
                  className="btn-add"
                  onClick={() => {
                    const nuevoItem = {
                      repuesto: formData.repuesto,
                      cantidad: Number(formData.cantidad),
                      unidad: formData.unidad,
                    };

                    setFormData((prev) => ({
                      ...prev,
                      [grupo.key]: [...(prev[grupo.key] || []), nuevoItem],
                    }));

                    handleChange("repuesto", "");
                    handleChange("cantidad", "");
                    handleChange("unidad", "");
                  }}
                >
                  +
                </button>
              </div>
            </div>

            <div className="form-items">
              <strong>Repuestos a utilizar</strong>
              <hr className="form-line" />
              {(formData[grupo.key] || []).map((item, index) => (
                <div key={index} className="form-item">
                  <strong className="title-txt">{item.repuesto}</strong>
                  <span className="description-txt">
                    {buscarCampo(localStock, item.repuesto, "label")}{" "}
                  </span>
                  <strong className="mini-txt">
                    {item.cantidad}{" "}
                    {buscarCampo(localStock, item.repuesto, "unidad")}
                  </strong>
                  <DeleteButton onClose={() => onDelete(grupo.key, index)} />
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default FormComplete;
